import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d7616d1e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d7616d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7616d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7616d1e')) {
      api.createRecord('d7616d1e', component.options)
    } else {
      api.reload('d7616d1e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d7616d1e&scoped=true&", function () {
      api.rerender('d7616d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XxwAyTtv83ZE/JS/comp/CookieBox.vue"
export default component.exports